if (!customElements.get('compare-products')) {
  customElements.define(
    'compare-products',
    class CompareProducts extends HTMLElement {
      connectedCallback() {
        this.tabs = this.querySelectorAll('[data-compare-tab]');
        this.images = this.querySelectorAll('[data-compare-target]');
        this.sliderWrapper = this.querySelector('[data-compare-slider-wrapper]');
        this.sliderEl = this.querySelector('[data-compare-slider]');

        this.tabs.forEach((tab) => {
          tab.addEventListener('click', () => this.showView(tab.dataset.target));
        });

        this.initSlider();

        this.onResize = () => {
          this.updateNavHeight();
          this.updateTitleRowHeight();
          this.updatePriceRowHeight();
          this.updateSpecRowHeights();
        };
        window.addEventListener('resize', this.onResize);
        this.updateNavHeight();
        this.updateTitleRowHeight();
        this.updatePriceRowHeight();
        this.updateSpecRowHeights();
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
        this.destroySlider();
      }

      get isMobile() {
        return window.innerWidth < 1024;
      }

      updateNavHeight() {
        const media = this.sliderEl?.querySelector('.compare-products__media');
        if (!media || !this.sliderWrapper) return;
        this.sliderWrapper.style.setProperty('--compare-media-height', `${media.offsetHeight}px`);
      }

      syncMaxHeight(selector, cssVar) {
        const rows = this.querySelectorAll(selector);
        if (!rows.length) return;
        this.style.removeProperty(cssVar);
        const maxHeight = Math.max(...Array.from(rows).map((row) => row.offsetHeight));
        this.style.setProperty(cssVar, `${maxHeight}px`);
      }

      updateTitleRowHeight() {
        this.syncMaxHeight('.compare-products__title-row', '--compare-title-row-height');
      }

      updatePriceRowHeight() {
        this.syncMaxHeight('.compare-products__price--standalone', '--compare-price-row-height');
      }

      updateSpecRowHeights() {
        const cards = this.querySelectorAll('.compare-products__card');
        if (!cards.length) return;

        const rowsByIndex = Array.from(cards).map((card) => Array.from(card.querySelectorAll('.compare-products__spec')));
        const rowCount = Math.max(0, ...rowsByIndex.map((rows) => rows.length));

        for (let i = 0; i < rowCount; i += 1) {
          const rows = rowsByIndex.map((rows) => rows[i]).filter(Boolean);
          rows.forEach((row) => row.style.removeProperty('min-height'));
          if (!this.isMobile) continue;
          const maxHeight = Math.max(...rows.map((row) => row.offsetHeight));
          rows.forEach((row) => {
            row.style.minHeight = `${maxHeight}px`;
          });
        }
      }

      showView(target) {
        this.tabs.forEach((tab) => tab.classList.toggle('is-active', tab.dataset.target === target));
        this.images.forEach((image) => image.classList.toggle('is-active', image.dataset.compareTarget.trim() === target));
      }

      destroySlider() {
        if (this.swiper) {
          this.swiper.destroy(true, true);
          this.swiper = null;
        }
      }

      initSlider() {
        if (!this.sliderEl || typeof Swiper === 'undefined') return;

        const prevEl = this.sliderWrapper?.querySelector('[data-compare-prev]');
        const nextEl = this.sliderWrapper?.querySelector('[data-compare-next]');
        const slideCount = this.sliderEl.querySelectorAll('.swiper-slide').length;
        const desktopDisabled = slideCount <= 4;

        this.swiper = new Swiper(this.sliderEl, {
          slidesPerView: 2,
          spaceBetween: 12,
          watchOverflow: true,
          navigation: prevEl && nextEl ? { prevEl, nextEl } : false,
          breakpoints: {
            1024: {
              slidesPerView: 4,
              spaceBetween: 16,
              enabled: !desktopDisabled,
            },
          },
        });
      }
    }
  );
}
